<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  a {
    text-decoration: none;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  let { call, skeleton = false } = $props();
</script>

{#if call.recorded}
  <a href={`/calls?callId=${call.callId}`} target="_blank">
    <Button
      kind="secondary"
      class={skeleton ? "disabled" : ""}
      leadingIcon="far fa-play"
      style="border-radius: 200px;"
      disabled={skeleton}
    />
  </a>
{/if}
